// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_order_order_module_ts":"efe5c45e5f234e43","src_app_modules_product_product_module_ts":"ff9a59a76e2733d8","src_app_modules_report_report_module_ts":"b839feb6eb96d6f5"}[chunkId] + ".js";
};